import { gql } from "@apollo/client";

export const GET_CLIENT_HUB_ZONE_IMPORT_TASK = gql`
    query GetClientHubZoneImportTask($taskNo: String!) {
        getClientHubZoneImportTask(taskNo: $taskNo) {
            id
            taskNo
            channelId
            channelName
            hubId
            hubName
            activeTime
            filename
            submitterId
            status
            totalCount
            importedCount
            failedCount
            errorMessage
            createdAt
            updatedAt
        }
    }
`;

export interface ClientHubZoneImportTaskType {
    id: number;
    taskNo: string;
    channelId: number;
    channelName?: string;
    hubId: number;
    hubName?: string;
    activeTime?: number | null;
    filename: string;
    submitterId: number;
    status: number;
    totalCount: number;
    importedCount: number;
    failedCount: number;
    errorMessage?: string;
    createdAt: number;
    updatedAt: number;
}

export interface GetClientHubZoneImportTaskResponse {
    getClientHubZoneImportTask: ClientHubZoneImportTaskType | null;
}

